import { MapInterface } from '@studio/map/utils';

import { createOptimizedContext } from '@src/contexts/createOptimizedContext';

export type MapInstance = MapInterface | null;

interface MapViewContext {
  area: number;
  hasArea: boolean;
  mapInstance: MapInstance;
  toolKey: string | null;
  isAoiUploading: boolean;
}

interface MapViewCompareContext {
  lMapInstance: MapInstance;
  rMapInstance: MapInstance;
}

export const {
  Provider: MapViewProvider,
  useStoreSelector: useMapViewSelector,
  useStoreDispatch: useMapViewDispatch,
  useStore: useMapViewStore
} = createOptimizedContext<MapViewContext>({
  area: 0,
  hasArea: false,
  mapInstance: null,
  toolKey: null,
  isAoiUploading: false
});

export const {
  Provider: MapViewCompareProvider,
  useStoreSelector: useMapViewCompareSelector,
  useStoreDispatch: useMapViewCompareDispatch
} = createOptimizedContext<MapViewCompareContext>({
  lMapInstance: null,
  rMapInstance: null
});
